<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">SDK初始化与释放</h1>
		<h3 class="doc_main_h3">（1）SDK初始化</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			进行SDK的初始化跟踪，首次授权需访问外网。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public SKFace(Context MCcontext)
public boolean SKFaceInitSDK(String ApiKey, String ApiSecret, final SDKInitCallbackInterface SDKInitCallback
)
// SDK初始化回调接口
public interface SDKInitCallbackInterface {
   void SDKInitCallback(int Code, String Msg);
}</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）MCcontext：Android上下文对象</p>
        <p class="doc_main_p">（2）ApiKey：当前APP所申请的SKEye的API_KEY</p>
        <p class="doc_main_p">（3）ApiSecret：当前APP所申请的SKEye的API_SECRET</p>
        <p class="doc_main_p">（4）SDKInitCallback (int Code, String Msg)：SDK授权结果回调函数，Code:初始化状态码，Msg：初始化状态信息</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">boolean类型,SDK初始化结果，成功为true，失败为false。初始化成功并且授权成功后可调用检测相关接口（注意：初始化成功并不表示授权成功）。
		</p>
		<h3 class="doc_main_h3">授权结果错误码信息</h3>
		<authority-error-code></authority-error-code>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 初始化SDK
skFace = new SKFace(getApplicationContext());
//“xxxxxx”为替换符，注意使用合法API-KEY、API-SECRET
boolean sdkInitState = 
skFace.SKFaceInitSDK(“xxxxxx”, “xxxxxx”, new SDKInitCallbackInterface() {
    @Override
    public void SDKInitCallback(int Code, String Msg) {
        // TODO：授权结果
        Log.e(Tag, "授权结果Code：" + Code + "， Msg:" + Msg);
    }
});</code></pre>
<h3 class="doc_main_h3">（2）SDK释放</h3>
<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			调用该接口将释放SDK相关资源，SDK将不能继续使用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceReleaseSDK() </code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">无</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceReleaseSDK();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','基础接口','SDK初始化与释放'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/basics/SkfaceSdkInitializationRelease.vue